// extracted by mini-css-extract-plugin
export default {"agreeTermsLabel":"styles__agreeTermsLabel___iet6M","footerLink":"styles__footerLink___SUIup","link":"styles__link___x7pro"};